import { render, staticRenderFns } from "./UserProfileSubscribed.vue?vue&type=template&id=9d22b934"
import script from "./UserProfileSubscribed.vue?vue&type=script&lang=js"
export * from "./UserProfileSubscribed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports